import {Controller} from "@hotwired/stimulus"
import {Sortable} from "sortablejs"

export default class extends Controller {
    static targets = ["list", "item"]
    static values = {url: String}

    connect() {
        this.initializeSortable()
    }

    disconnect() {
        if (this.sortable) {
            this.sortable.destroy()
            this.sortable = null
        }
    }

    initializeSortable() {
        // Destroy existing sortable instance if it exists
        if (this.sortable) {
            this.sortable.destroy()
            this.sortable = null
        }

        // Create a new sortable instance
        this.sortable = Sortable.create(this.listTarget, {
            animation: 150,
            handle: ".cursor-move",
            onEnd: this.onDragEnd.bind(this)
        })
    }

    onDragEnd(event) {
        const articleIds = this.itemTargets.map(item => item.dataset.articleId)

        // Use Turbo Stream request instead of fetch
        fetch(this.urlValue, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({article_ids: articleIds})
        })
            .then(response => {
                if (response.ok) {
                    return response.text()
                }
                throw new Error('Network response was not ok')
            })
            .then(html => {
                // Process the Turbo Stream response
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const streamElements = doc.querySelectorAll('turbo-stream')

                // Apply each turbo-stream action to the DOM
                streamElements.forEach(streamElement => {
                    const action = streamElement.getAttribute('action')
                    const target = streamElement.getAttribute('target')
                    const content = streamElement.querySelector('template').content.cloneNode(true)

                    if (action === 'replace' && target === 'newsletter_articles_section') {
                        const targetElement = document.getElementById(target)
                        if (targetElement) {
                            // Instead of replacing the entire element, update its innerHTML
                            // This preserves the Stimulus controller connection
                            const tempDiv = document.createElement('div')
                            tempDiv.appendChild(content)

                            // Extract the inner content of the turbo-frame
                            const targetInTempDiv = tempDiv.querySelector(`#${target}`)
                            if (targetInTempDiv) {
                                const innerContent = targetInTempDiv.innerHTML
                                targetElement.innerHTML = innerContent
                            } else {
                                // If we can't find the element with the target ID, use the entire content
                                targetElement.innerHTML = tempDiv.innerHTML
                            }

                            // Reinitialize the sortable instance
                            this.initializeSortable()
                        }
                    } else if (action === 'replace' && target === 'flash-messages') {
                        const targetElement = document.getElementById(target)
                        if (targetElement) {
                            targetElement.replaceWith(content)
                        }
                    }
                })
            })
            .catch(error => {
                console.error("Error:", error)
            })
    }
}
